import { EndpointDefinition } from "../_sdk/types/common";

export const apiName = "comments";

export const endpoints: { [key: string]: EndpointDefinition } = {
    createComment: {
        route: "/comments",
        method: "POST"
    },
    getComments: {
        route: "/comments",
        method: "GET"
    },
    updateComment: {
        route: "/comments/:id",
        method: "PUT"
    },
    deleteComment: {
        route: "/comments/:id",
        method: "DELETE"
    },
    markCommentAsRead: {
        route: "/comments/:id/read",
        method: "PUT"
    }
};
